import { ReactNode, createContext } from "react";
import { FiltrosPedidos } from "../../types/PedidoListagem";

export type PedidosContextType = {
    setFiltros: React.Dispatch<React.SetStateAction<FiltrosPedidos>>;
    filtros: FiltrosPedidos;
};

export const PedidosContext = createContext<PedidosContextType>(null!);
